import React from 'react';

import classNames from 'classnames';
import ButtonRibbon from '../_utils/button-ribbon';
import sendToGoogleAnalytics from '../_libs/analytics/builder-send-to-google-analytics';

const LoaderNav = (props) => {
  const serviceTitle = {
    upload: props.isMobile ? 'My Phone' : 'My Devices',
    mobile: 'My Phone',
    albums: `My ${window.store} Photos`,
    picasa: 'Google Photos',
    facebook: 'Facebook',
    instagram: 'Instagram',
  };

  const handleClick = (service) => {
    sendToGoogleAnalytics('loader-nav', `${serviceTitle[service]}`);
  };

  return (
    <ButtonRibbon className="loader-nav" role="tablist" loaderNav alwaysFlexButtons>
      {props.imgSources.map(({ service, title }, index) => {
        const selected = props.activeSource === index;
        return (
          <button
            aria-controls={'image-loader-service-' + service}
            aria-label={`${serviceTitle[service]}`}
            aria-selected={selected}
            className={classNames('service', service, { active: selected })}
            key={service}
            role="tab"
            type="button"
            onClick={() => {
              props.onSourceSelect(index, service);
              handleClick(service);
            }}>
            {serviceTitle[service]}
          </button>
        );
      })}
    </ButtonRibbon>
  );
};

export default LoaderNav;
